/**
 * PATH: apps/quote/src/components/builder/panels/inspector/SubconTab.tsx
 * PURPOSE: Subcontractor tab for the row inspector
 */

import { formatCurrency } from '@/lib/utils'
import type { QuoteLineItem } from '@/lib/quoteApi'

export default function SubconTab({ lineItem }: { lineItem: QuoteLineItem }) {
  return (
    <div className="p-3 space-y-3">
      <div>
        <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Subcontractor</h3>
        <p className="text-xs text-slate-500 dark:text-slate-400">
          External subcontractor quotes
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
            Quote Amount
          </label>
          <input
            type="number"
            defaultValue={lineItem.subcon_quote || 0}
            className="w-full px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-sm"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1">
            Days
          </label>
          <input
            type="number"
            defaultValue={lineItem.subcon_days || 0}
            className="w-full px-2.5 py-1.5 border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 text-sm"
          />
        </div>
      </div>

      <div className="p-2.5 bg-slate-100 dark:bg-slate-800 rounded-lg space-y-1">
        <div className="flex justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Subcon Cost:</span>
          <span className="font-medium text-slate-900 dark:text-white">
            {formatCurrency(lineItem.subcon_cost || 0)}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-slate-600 dark:text-slate-400">Chargeout:</span>
          <span className="font-medium text-emerald-600">
            {formatCurrency(lineItem.subcon_chargeout || 0)}
          </span>
        </div>
      </div>
    </div>
  )
}
